export class SkuMetadata {
  constructor(
    public id: number,
    public name: string,
    public countryName: string,
    public industryName: string,
    public categoryName: string,
    public subCategoryName: string,
    public supplierName: string,
    public brandName: string,
    public subBrandName: string,
    public retailerNames: string[],
    public attributes: string[],
    public ingredients: string[],
    public emiImageUrl: string,
    public feedbackReviewPending: boolean
  ) { }
}
